import { render, staticRenderFns } from "./footWorld.vue?vue&type=template&id=361f7fdc&scoped=true"
import script from "./footWorld.vue?vue&type=script&lang=js"
export * from "./footWorld.vue?vue&type=script&lang=js"
import style0 from "./footWorld.vue?vue&type=style&index=0&id=361f7fdc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "361f7fdc",
  null
  
)

export default component.exports